import css from './Filter.module.scss';
import FormComponent from '../../../../../../widgets/form/FormComponent/FormComponent';
import { useContext, useEffect, useMemo, useState } from 'react';
import T from '../../../../../../common/components/T';
import { getData } from '../../../../../../common/utils/router';
import UserContext, { UserProfileContext } from '../../../../../../common/utils/getContext';
import { formStyles } from './helpers';
import classNames from 'classnames';
import { getMemoizedData } from '../../../../../../common/utils/memo';

export default function Filter({ closeHandler, attributes = [], url, setData, initValue, filterTrigger, resetFilterParams }) {
    const { userToken, lang } = useContext(UserContext);
    const { profileData } = useContext(UserProfileContext);
    const [formDataMain, setFormDataMain] = useState(initValue || {});

    const [fromPeriodNumber, setFromPeriodNumber] = useState(initValue[attributes[0]]?.value);

    const [periods, setPeriods] = useState([]);

    useEffect(() => {
        getMemoizedData('/api/v1/periods', userToken, lang).then(({ data }) => {
            if (Array.isArray(data)) setPeriods(data?.sort((a, b) => a.id - b.id));
        });
    }, [userToken, lang]);

    // з якого періоду беремо
    const optionsFrom = useMemo(() => {
        const numberTo = profileData?.marketing_profile?.marketing_period_current?.id || 20;
        const numberFrom = profileData?.marketing_profile?.marketing_period?.id || 1;
        if (numberFrom && numberTo && periods?.length) {
            const periodsStartIdx = periods?.findIndex((period) => +period?.id === +numberFrom);
            const periodsEndIdx = periods?.findIndex((period) => +period?.id === +numberTo);
            const periodsArray = periods.slice(periodsStartIdx, periodsEndIdx + 1);
            return periodsArray
                .map((period) => ({
                    value: period?.id,
                    label: period?.id_formatted
                }))
                .sort((a, b) => +b.value - +a.value);
        }
        return [];
    }, [profileData, periods]);

    // по який період беремо
    const optionsTo = useMemo(() => {
        const numberTo = profileData?.marketing_profile?.marketing_period_current?.id || 20;
        if (numberTo && periods?.length) {
            const periodsStartIdx = periods?.findIndex((period) => +period?.id === +fromPeriodNumber);
            const periodsEndIdx = periods?.findIndex((period) => +period?.id === +numberTo);
            const periodsArray = periods?.slice(periodsStartIdx, periodsEndIdx + 1);
            return periodsArray
                .map((period) => ({
                    value: period.id,
                    label: period?.id_formatted
                }))
                .sort((a, b) => +b?.value - +a?.value);
        }
        return [];
    }, [fromPeriodNumber, profileData, periods]);

    const setFormData = (key, val) => {
        let fromPeriod = +val?.value || +val;
        if (key === attributes[0]) {
            setFromPeriodNumber(fromPeriod);
        }
        setFormDataMain((state) => {
            const newInfo = {
                [key]: val
            };
            // якщо період з якого більший по який беремо, то по який ставимо в null
            if (key === attributes[0] && state?.[attributes[1]] && state?.[attributes[1]]?.value <= fromPeriod - 1) {
                newInfo[attributes[1]] = null;
            }
            return {
                ...state,
                ...newInfo
            };
        });
    };
    // хендлер фільтру
    const sender = (dataToSend, setAllowedSend) => {
        const filterUrl = Object.keys(formDataMain || {}).reduce((accum, key, idx) => {
            if (!formDataMain[key]) return accum;
            if (idx === 0) {
                if (url.includes('?')) {
                    accum += `&filter[${key}]=${formDataMain[key]?.value}`;
                } else {
                    accum += `?filter[${key}]=${formDataMain[key]?.value}`;
                }
            } else {
                accum += `&filter[${key}]=${formDataMain[key]?.value}`;
            }
            return accum;
        }, '');
        if (typeof filterTrigger === 'function') filterTrigger(filterUrl);
        closeHandler();
        getData(url + filterUrl, userToken, lang).then((res) => {
            setAllowedSend(true);
            setData(res);
        });
    };

    // скидуємо фільтр
    const resetFilter = () => {
        if (typeof filterTrigger === 'function') filterTrigger('');
        closeHandler();
        getData(url + `${url.includes('?') ? `&${resetFilterParams}` : `?${resetFilterParams}`}`, userToken, lang).then((res) => {
            setData(res);
        });
    };

    return (
        <div className={css.filter}>
            <FormComponent
                customData={{
                    fieldsWrapper: css.fields,
                    customFormButton: {
                        wrapper: css.buttons,
                        flex: css.buttonsFlex,
                        ok: {
                            singleButton: css.btnPadding,
                            butText: css.butText
                        },
                        cancel: {
                            singleButton: classNames(css.btnPadding, css.cancelBtn),
                            butText: css.butText
                        }
                    }
                }}
                formStyles={formStyles(css, attributes)}
                data={[
                    {
                        attribute: attributes[0],
                        type: 'select',
                        options: optionsFrom,
                        value: formDataMain[attributes[0]],
                        title: { body: <T textName='from-office' defaultStr='От' page='/office' /> },
                        isSearchable: false
                    },
                    {
                        attribute: 'separator',
                        type: 'info-field',
                        html: <span>-</span>
                    },
                    {
                        attribute: attributes[1],
                        type: 'select',
                        options: optionsTo,
                        value: formDataMain[attributes[1]],
                        title: { body: <T textName='to-office' defaultStr='До' page='/office' /> },
                        isSearchable: false
                    }
                ]}
                setFormDataMain={setFormData}
                formDataMain={formDataMain}
                buttons={[
                    {
                        type: 'cancel',
                        clickFunc: resetFilter,
                        buttonText: <T textName='reset' defaultStr='Сбросить' />
                    },
                    {
                        type: 'ok',
                        buttonText: <T textName='apply-structure' defaultStr='Применить' page='/office' />
                    }
                ]}
                sendData={{
                    sender
                }}
            />
        </div>
    );
}
